import React from 'react';

const resourceToCollection = (
    resources,
    {
        name,
        list,
        form,
        approve,
        groupParent,
        children,
        routes = [],
        requiresPermission = true,
        visibleWhen = null,
    },
) => {
    if (name && list) {
        resources.push({
            name,
            requiresPermission,
            path: `/${name}`,
            component: list,
            listable: true,
            visibleWhen,
        });
        resources.push({
            name,
            requiresPermission,
            path: `/${name}/page/:page`,
            component: list,
            listable: false,
            visibleWhen,
        });
    }

    if (name && form) {
        resources.push({
            name,
            requiresPermission,
            path: `/${name}/new`,
            component: form,
            listable: false,
            visibleWhen,
        });
        resources.push({
            name,
            requiresPermission,
            path: `/${name}/:id/show`,
            component: form,
            listable: false,
            visibleWhen,
        });
    }

    if (name && approve) {
        resources.push({
            name,
            requiresPermission,
            path: `/${name}/:id/show`,
            component: approve,
            listable: false,
            visibleWhen,
        });
        resources.push({
            name,
            requiresPermission,
            path: `/${name}/:id/approve`,
            component: approve,
            listable: false,
            visibleWhen,
        });
        resources.push({
            name,
            requiresPermission,
            path: `/${name}/:id/reject`,
            component: approve,
            listable: false,
            visibleWhen,
        });
    }

    if (name && groupParent) {
        resources.push({
            name,
            requiresPermission,
            group: name,
            groupParent,
            listable: true,
            children,
            visibleWhen,
        });

        children.map((child) => {
            const {
                name: childName,
                list: childList,
                form: childForm,
                group: childGroup,
                requiresPermission: childRequiresPermission = true,
                visibleWhen: childVisibleWhen = null,
            } = child.props;

            if (childName && childList) {
                resources.push({
                    name: childName,
                    requiresPermission: childRequiresPermission,
                    path: `/${childName}`,
                    component: childList,
                    listable: true,
                    group: childGroup,
                    visibleWhen: childVisibleWhen,
                });
                resources.push({
                    name: childName,
                    requiresPermission: childRequiresPermission,
                    path: `/${childName}/page/:page`,
                    component: childList,
                    listable: false,
                    group: childGroup,
                    visibleWhen: childVisibleWhen,
                });
            }

            if (childName && childForm) {
                resources.push({
                    name: childGroup,
                    requiresPermission: childRequiresPermission,
                    path: `/${childGroup}/new`,
                    component: childForm,
                    listable: false,
                    group: childGroup,
                    visibleWhen: childVisibleWhen,
                });
                resources.push({
                    name: childGroup,
                    requiresPermission: childRequiresPermission,
                    path: `/${childGroup}/:id/show`,
                    component: childForm,
                    listable: false,
                    group: childGroup,
                    visibleWhen: childVisibleWhen,
                });
            }
            return null;
        });
    }

    routes.map(({ path, listable, component }) =>
        resources.push({
            name,
            requiresPermission,
            path: `/${name}${path}`,
            component,
            listable,
            visibleWhen,
        }),
    );
};

const registerResources = (children) => {
    const resources = [];
    React.Children.forEach(children, (child) =>
        resourceToCollection(resources, child.props),
    );

    return resources;
};

export default registerResources;
